function makeSmallGallery($el) {
  $("ul.small-gallery-tab li", $el).each(function (idx, el) {
    if (idx % 4 == 0 || !$(el).next().length) {
      var d = idx * 50;
      $(el).delay(d).fadeIn();
      $(el).next().delay(d).fadeIn();
      $(el).next().next().delay(d).fadeIn();
      $(el).next().next().next().delay(d).fadeIn();
    }
  });
  $("ul.small-gallery-tab li", $el).hover(
    function () {
      $(this).css({
        "z-index": "10",
      }); /*Add a higher z-index value so this image stays on top*/
      var name = $(".design-thumbnail", $(this)).attr("title");

      $(".smallgallery-3dview", $(this)).css({
        marginTop: "-50px",
        marginLeft: "-70px",
        top: "50%",
        left: "50%",
        width: "160px",
        height: "120px",
      });

      $(this)
        .find("img")
        .addClass("hover")
        .stop() /* Add class of "hover", then stop animation queue buildup*/
        .css({
          marginTop: "-50px",
          marginLeft: "-70px",
          top: "50%",
          left: "50%",
          width: "160px",
          height: "120px",
        })
        .after(
          "<div class='absolute bold acenter' style='background-color: white; opacity: 0.4; top: -16px; left: -26px; width: 160px; height: 30px;'>" +
            name +
            "</div>"
        );
    },
    function () {
      $(this).css({
        "z-index": "0",
      }); /* Set z-index back to 0 */
      $(this)
        .find("img")
        .removeClass("hover")
        .stop() /* Remove the "hover" class , then stop animation queue buildup*/
        .css({
          marginTop: "0",
          marginLeft: "0",
          top: "4px",
          left: "4px",
          width: "80px",
          height: "60px",
        })
        .next()
        .remove();
      $(".smallgallery-3dview", $(this)).css({
        marginTop: "0",
        marginLeft: "0",
        top: "4px",
        left: "4px",
        width: "80px",
        height: "60px",
      });
    }
  );

  $(".ui-tabs", $el).tabs();
}
$(document).ready(function () {
  if (jQuery().tabs) {
    makeSmallGallery();
  }
});
